"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _project = require("@/api/project/project");
var _public = require("@/api/public/public");
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      formRole: {
        name: [{
          required: true,
          message: "请填写作品项名称",
          trigger: "blur"
        }],
        // fileType: [
        //   { required: true, message: "请选择作品文件类型", trigger: "blur" }
        // ],
        size: [{
          required: true,
          message: "请选择作品文件大小",
          trigger: "blur"
        }, {
          validator: _validate.isInteger,
          trigger: "blur"
        }]
        // requirements: [
        //   { required: true, message: "请选择作品文件上传要求", trigger: "blur" }
        // ]
      },
      typeList: [],
      addForm: {
        formList: [{
          name: "",
          requirements: "",
          size: "1",
          fileType: "mp4",
          matchId: this.$route.query.matchId,
          stageId: this.$route.query.stageId,
          groupId: this.$route.query.groupId,
          id: "",
          sort: ""
        }]
      }
    };
  },
  methods: {
    // 获取该组别的作品项设置
    getWorksSet: function getWorksSet() {
      var _this = this;
      (0, _project.worksSet)({
        groupId: this.$route.query.groupId,
        matchId: this.$route.query.matchId,
        stageId: this.$route.query.stageId
      }).then(function (res) {
        console.log(res, 'huixian');
        if (res.data.length > 0) {
          console.log(res.data, 'huixian');
          _this.addForm.formList = res.data;
        }
      });
    },
    // 获取文件类型
    getFileType: function getFileType() {
      var _this2 = this;
      (0, _public.selectList)({
        businessTypeId: 1
      }).then(function (res) {
        _this2.typeList = res.data;
      });
    },
    // 提交
    submit: function submit(v) {
      var _this3 = this;
      console.log(this.addForm.formList, "list");
      this.$refs[v].validate(function (valid) {
        if (valid) {
          _this3.addForm.formList.forEach(function (item, index, arr) {
            // item.matchId = this.$route.query.matchId;
            // item.stageId = this.$route.query.stageId;
            // item.groupId = this.$route.query.groupId;
            item.sort = index;
          });
          (0, _project.worksSubmit)({
            groupId: _this3.$route.query.groupId,
            matchId: _this3.$route.query.matchId,
            stageId: _this3.$route.query.stageId,
            matchWorksRuleParamList: _this3.addForm.formList
          }).then(function (res) {
            if (res.code === 2000) {
              _this3.$message.success("操作成功。");
              history.go(-1);
            }
          });
        } else {
          _this3.$message.error("请核对填写内容。");
        }
      });
    },
    // 返回
    isBack: function isBack() {
      history.back(-1);
    },
    addItem: function addItem() {
      this.addForm.formList.push({
        name: "",
        requirements: "",
        size: "1",
        fileType: "mp4",
        matchId: this.$route.query.matchId,
        stageId: this.$route.query.stageId,
        groupId: this.$route.query.groupId,
        id: "",
        sort: ""
      });
    },
    removeItem: function removeItem(e) {
      this.addForm.formList.splice(e, 1);
    }
  },
  created: function created() {
    this.getWorksSet();
    this.getFileType();
  }
};